import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import {
  sendPasswordResetEmail,
  confirmPasswordReset,
} from "../../services/authNew";

const ResetPassword = (props) => {
  const { setToast } = props;

  const location = useLocation();
  const token = new URLSearchParams(location.search).get("token") || "";

  const [identifier, setIdentifier] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChangeIdentifier = (e) => setIdentifier(e.target.value);
  const handleChangePassword = (e) => setNewPassword(e.target.value);

  const isReadyToSubmit = token ? newPassword.length >= 8 : !!identifier;

  const handleResetPassword = () => {
    setIsSubmitting(true);

    const request = token
      ? confirmPasswordReset(token, newPassword)
      : sendPasswordResetEmail(identifier);

    request
      .then((msg) => {
        setIsSubmitting(false);
        setSuccess(true);

        setToast({
          show: true,
          type: "success",
          message:
            msg ||
            (token
              ? "Password has been reset. You can now sign in with your new password."
              : "If an account exists for this email, you will receive a password reset link shortly."),
        });
      })
      .catch((error) => {
        setIsSubmitting(false);

        console.log(
          token
            ? "Confirm password reset error"
            : "Request password reset error",
          error
        );
        setToast({
          show: true,
          type: "warning",
          message: error.message || "Something went wrong. Please try again",
        });
      });
  };

  useEffect(() => {
    if (location.search && !token) {
      setToast({
        show: true,
        type: "warning",
        message: "Missing or invalid reset link. Please request a new one.",
      });
    }
  }, [token, location.search]);

  return (
    <div className="card">
      <div className="card-section">
        <h3>{token ? "Set a new password" : "Reset your password"}</h3>
        <div className="form-block fill push-down">
          {token ? (
            <div className="control push-down">
              <label>New password</label>
              <input
                type="password"
                className="input-2"
                maxLength="256"
                id="new-password"
                name="newpassword"
                value={newPassword}
                onChange={handleChangePassword}
              />
              <label className="helper">No less than 8 characters.</label>
            </div>
          ) : (
            <div className="control push-down">
              <label>Email</label>
              <input
                type="email"
                className="input-2"
                maxLength="256"
                id="identifier"
                name="identifier"
                value={identifier}
                onChange={handleChangeIdentifier}
              />
            </div>
          )}
        </div>
        {success ? (
          <span className="button small is-disabled" disabled>
            {token ? "Password reset" : "Reset link sent"}
          </span>
        ) : !isReadyToSubmit ? (
          <span className="button small is-disabled" disabled>
            Reset password
          </span>
        ) : isSubmitting ? (
          <span className="button small is-disabled" disabled>
            {token ? "Resetting password..." : "Sending..."}
          </span>
        ) : (
          <span className="button small" onClick={handleResetPassword}>
            Reset password
          </span>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
